export function getAdvertisementImageSrc(imageBase64?: string, imageContentType?: string): string | undefined {
  if (!imageBase64?.trim()) {
    return undefined;
  }

  const normalizedContentType = (imageContentType || 'image/jpeg').trim() || 'image/jpeg';
  return `data:${normalizedContentType};base64,${imageBase64}`;
}

